import { GlobalSettings, FieldLabels,ShowFields, DocLinks, SiteFeatures,Site,Paths, FileType,Statuses, Multitenancy} from "../services/interfaces";

export  const gSettings = async (): Promise<GlobalSettings> => {    
        const configString = await fetch("/api/GetConfig?section=GlobalSettings").then((response) => {return(response.json())});
        //console.log(configString);
        return configString;
}

export const fieldLables = async(): Promise<FieldLabels>=>{
        const configString = await fetch("/api/GetConfig?section=FieldLabels").then((response)=>{return (response.json())});
        return configString;
}

export const showFields = async(): Promise<ShowFields>=>{
        const configString = await fetch("/api/GetConfig?section=ShowFields").then((response)=>{return (response.json())});
        return configString;
}

export const docLinks = async(): Promise<DocLinks>=>{
        const configString = await fetch("/api/GetConfig?section=DocLinks").then((response)=>{return (response.json())});
        //console.log(configString);
        return configString;
}

export const paths = async(): Promise<Paths>=>{
        const configString = await fetch("/api/GetConfig?section=Paths").then((response)=>{return (response.json())});
        //console.log(configString);
        return configString;
}

export const statuses = async(): Promise<Statuses>=>{
        const configString = await fetch("/api/GetConfig?section=Statuses").then((response)=>{return (response.json())});
        //console.log(configString);
        return configString;
}

export const tenants = async(): Promise <Multitenancy>=>{
        const configString = await fetch("/api/GetConfig?section=Multitenancy").then((response)=>{return(response.json())});
        //console.log(configString);
        return configString;
}


export const siteFeatures = async(findsite:string): Promise<Site|undefined>=>{
        const configString = await fetch("/api/GetConfig?section=SiteFeatures").then((response)=>{return (response.json() as Promise<SiteFeatures>)});
        const foundSite = configString.sites.find(site => site.site.includes(findsite));
        if (!foundSite) {
            console.log(`Site with name ${findsite} not found`);
        }
        return foundSite;
}

interface FileTypeList{
        types:Array<FileType>
}
export const fileTypes = async(): Promise<FileTypeList>=>{
        const configString = await fetch("/api/GetConfig?section=FileTypes").then((response)=>{return (response.json())});
        //console.log(configString);
        return configString;
}